
    <template>
    <svg viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.25 7.51163L7 12.25L1.75 7.51163L12.25 7.51163Z" fill="currentColor"/>
    <path d="M9.55957 1.75V9.03018H4.44082L4.44082 1.75L9.55957 1.75Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowRough',
    }) as DefineComponent
    </script>
    